import { Component } from "@angular/core";
// superclass
import { Module } from "../module.component";
// services
import { Status } from "../../service/status.service";
import { MaterialDocService } from "./material-doc.service";
// models
import { MaterialDocRequest } from "../../model/materials/material_doc_request.model";
import { MaterialDocResponse } from "../../model/materials/material_doc_response.model";

@Component({
    selector: "app-modal-material-doc",
    templateUrl: "./modal-material-doc.component.html",
    providers: [MaterialDocService]
})
export class ModalMaterialDocComponent extends Module {
    public visible = false;
    public visibleAnimate = false;
    material_description = "";

    material_doc_request = new MaterialDocRequest();
    material_doc_response = new MaterialDocResponse();
    globalExpansion = false;

    constructor(
        private status: Status,
        private materialDocService: MaterialDocService
    ) {
        super();
        this.setBindExposer(this.status.getExposer());
        this.getExposer().getModelsManager().material_doc_request;
    }

    // return true if service is stil searching
    isServiceSearching() {
        return this.materialDocService.isSearching();
    }

    // returns the status of the server query
    isResultEmpty() {
        return this.getModelsManager().material_doc_response.contained_bean
            .length === 0
            ? true
            : false;
    }

    show() {
        this.visible = true;
        setTimeout(() => {
            this.visibleAnimate = true;
        }, 100);
    }

    hide() {
        this.visibleAnimate = false;
        setTimeout(() => {
            this.visible = false;
        }, 100);
    }

    setDocs(materialCode, materialDescription, companyCode, language) {
        this.material_description = materialDescription;
        this.getModelsManager().material_doc_request.material = materialCode;
        this.getModelsManager().material_doc_request.company_code = companyCode;
        this.getModelsManager().material_doc_request.language = language;
        this.doSearch();
    }

    getMaterialDocResponse() {
        return this.getModelsManager().material_doc_response.contained_bean;
    }

    doSearch() {
        this.materialDocService.searchDocs();
    }


  downloadDocument(docType, docNumber, docVersion, docPart, filePath, fileName) {
    this.materialDocService.downloadDocument(docType, docNumber, docVersion, docPart, filePath, fileName);
  }


    getSplit(file, part) {
        return file.file_name.split(".")[part];
    }

    // Menage expansion state of table row
    switchGlobalExpansion() {
        this.globalExpansion = !this.globalExpansion;
        for (const element of this.getMaterialDocResponse()) {
            element.expanded = this.globalExpansion;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-material-doc/modal-material-doc.component.ts